import { PeopleReached } from "app/types"

export const peopleReached: PeopleReached = {
  resultSets: [
    {
      columns: [
        {
          name: "date",
          type: "Text",
        },
        {
          name: "id",
          type: "Number",
        },
        {
          name: "title",
          type: "Text",
        },
        {
          name: "impact",
          type: "Default",
        },
        {
          name: "viewCount",
          type: "Number",
        },
        {
          name: "score",
          type: "Number",
        },
        {
          name: "question",
          type: "Default",
        },
        {
          name: "score>0",
          type: "Default",
        },
        {
          name: "accepted",
          type: "Default",
        },
        {
          name: "score5+",
          type: "Default",
        },
        {
          name: "20%Votes",
          type: "Default",
        },
        {
          name: "top3",
          type: "Default",
        },
      ],
      rows: [
        [
          "2020-10-07",
          64242807,
          "Authentication versus Authorization",
          false,
          235263,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-09-29",
          64116440,
          "How to upgrade yarn version using terminal?",
          false,
          132802,
          1,
          false,
          true,
          false,
          false,
          false,
          false,
        ],
        [
          "2019-12-22",
          59447850,
          "Enumerate or map through a list with index and value in Dart",
          true,
          63348,
          14,
          false,
          true,
          null,
          true,
          null,
          null,
        ],
        [
          "2020-09-24",
          64042408,
          "How to upgrade/refresh the ag-grid after row delete?",
          false,
          56061,
          1,
          false,
          true,
          false,
          false,
          false,
          false,
        ],
        [
          "2020-10-26",
          64531069,
          "How to override the width of a TextField component with react Material UI?",
          false,
          51197,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-10-13",
          64341523,
          "How can I get the arguments called in jest mock function?",
          false,
          45841,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2019-11-19",
          58940459,
          "css3 animation on :hover; force entire animation",
          false,
          36711,
          1,
          false,
          true,
          false,
          false,
          false,
          false,
        ],
        [
          "2020-09-27",
          64088442,
          "How to disable selection of cells in ag-grid?",
          false,
          24051,
          1,
          false,
          true,
          false,
          false,
          false,
          false,
        ],
        [
          "2020-08-08",
          63318146,
          "How to detect when a image is loaded, that is provided via props, and change state in React?",
          true,
          21531,
          1,
          false,
          true,
          null,
          null,
          null,
          true,
        ],
        [
          "2020-08-23",
          63546822,
          "How to apply custom animation effect @keyframes in MaterialUI using makestyles()",
          true,
          9593,
          7,
          false,
          true,
          null,
          true,
          null,
          true,
        ],
        [
          "2020-10-14",
          64355324,
          "Javascript - can you throw an object in an Error?",
          false,
          9460,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-08-17",
          63448891,
          "Ag-Grid: How to save and reload column order",
          false,
          9287,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-07-13",
          62879437,
          "Add git information to create-react-app",
          false,
          9117,
          3,
          false,
          true,
          false,
          false,
          false,
          false,
        ],
        [
          "2020-09-02",
          63703951,
          "React hooks: accessing up-to-date state from within a callback",
          false,
          7458,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-02-09",
          60137206,
          "C# Code Minification Tools and Techniques",
          false,
          7409,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-10-10",
          64297098,
          "How to set a test for multiple fetches with Promise.all using jest",
          true,
          7401,
          1,
          false,
          true,
          null,
          null,
          true,
          true,
        ],
        [
          "2019-10-27",
          58577635,
          "Flutter TextField change Icon Color when Selected",
          true,
          7359,
          2,
          false,
          true,
          null,
          null,
          null,
          true,
        ],
        [
          "2019-12-16",
          59360135,
          "Gradient Text in Flutter",
          true,
          6984,
          20,
          false,
          true,
          null,
          true,
          true,
          true,
        ],
        [
          "2020-10-09",
          64283456,
          "String literal expected. when importing in typescript",
          true,
          5399,
          2,
          false,
          true,
          null,
          null,
          true,
          true,
        ],
        [
          "2020-08-09",
          63322558,
          "Clickable url value in ag-grid with react",
          true,
          5286,
          1,
          false,
          true,
          null,
          null,
          null,
          true,
        ],
        [
          "2020-10-15",
          64379060,
          "Checking if a component is unmounted using react hooks?",
          false,
          4933,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-08-21",
          63522444,
          "Why are logical assignment (&=) operators disallowed in Typescript?",
          false,
          4800,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-07-16",
          62942845,
          "ag-grid: keep header on top while scrolling",
          true,
          3876,
          1,
          false,
          true,
          null,
          null,
          true,
          true,
        ],
        [
          "2019-10-29",
          58604669,
          "Programmatically Lighten or Darken a hex color in dart",
          true,
          3541,
          22,
          false,
          true,
          null,
          true,
          true,
          true,
        ],
        [
          "2019-12-01",
          59121771,
          "How to animate the items rendered initially using Animated List in flutter",
          true,
          3400,
          10,
          false,
          true,
          true,
          true,
          true,
          true,
        ],
        [
          "2020-07-23",
          63056674,
          "Return type of a `yield call`",
          true,
          3349,
          1,
          false,
          true,
          null,
          null,
          null,
          true,
        ],
        [
          "2020-09-06",
          63761224,
          "React with JetBrains WebStorm auto import with absolute path instead of relative",
          false,
          3259,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2019-12-04",
          59182608,
          "Another exception was thrown: No Material widget found",
          true,
          3214,
          1,
          false,
          true,
          null,
          null,
          true,
          true,
        ],
        [
          "2018-04-29",
          50084775,
          "Way to obtain the word cursor is on, in WPF RichTextBox Control",
          false,
          2953,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-09-24",
          64048442,
          "Material-UI Capitalize words in React",
          false,
          2944,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-10-12",
          64320249,
          "Best way to test input value in dom-testing-library or react-testing-library",
          false,
          2936,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-09-29",
          64115884,
          "Error when updating create-react-app to 4.0 with typescript template",
          true,
          2645,
          18,
          true,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2019-11-29",
          59110637,
          "Flutter Theme FlatButton textColor in ButtonBar",
          true,
          2514,
          2,
          false,
          true,
          null,
          null,
          true,
          true,
        ],
        [
          "2020-08-29",
          63646879,
          'How to render "N items selected" rather than the list of N selected items with react-select',
          true,
          2336,
          3,
          false,
          true,
          null,
          null,
          true,
          true,
        ],
        [
          "2020-10-13",
          64336022,
          "Testing debounced function in React component with Jest and Enzyme",
          true,
          2130,
          2,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-01-16",
          59775443,
          "Test breaks when using Future.delayed",
          false,
          2070,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-10-22",
          64489155,
          "Using Jest's todo feature",
          false,
          1824,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-10-21",
          64471550,
          "Is It Possible To Extend A Jest / Expect Matcher",
          true,
          1333,
          1,
          false,
          true,
          null,
          null,
          true,
          true,
        ],
        [
          "2020-08-31",
          63672162,
          "How to work with path parameters in Axios Mock adapter",
          false,
          1283,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2019-08-25",
          57647788,
          "disable shortcut commands from textbox in wpf, keeping keystrokes detection",
          true,
          1000,
          1,
          false,
          true,
          null,
          null,
          true,
          true,
        ],
        [
          "2020-10-11",
          64307486,
          "How can I make Jest test for a thrown error silently",
          true,
          994,
          1,
          false,
          true,
          null,
          null,
          null,
          true,
        ],
        [
          "2019-10-17",
          58436335,
          "How to rename dart file in VSCode?",
          true,
          987,
          11,
          false,
          true,
          true,
          true,
          true,
          true,
        ],
        [
          "2019-12-22",
          59441148,
          "Flutter - No breaking words into newline at hyphen in Text",
          true,
          590,
          1,
          true,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-10-23",
          64493367,
          "List of questions with tag with the Stack Overflow API",
          false,
          587,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2018-06-07",
          50742365,
          "Select Word like Double Click in AvalonEdit",
          true,
          569,
          1,
          false,
          true,
          null,
          null,
          true,
          true,
        ],
        [
          "2019-12-01",
          59121811,
          "Flutter: Animation - How to make an animated list?",
          true,
          544,
          1,
          false,
          true,
          null,
          null,
          true,
          true,
        ],
        [
          "2020-09-01",
          63682244,
          "Get ag-grid instance by container div Id",
          true,
          462,
          2,
          false,
          true,
          null,
          null,
          true,
          true,
        ],
        [
          "2020-10-27",
          64559242,
          "React - Test if an element has 'disabled' set",
          false,
          349,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-08-08",
          63318405,
          "Crossfade between Gatsby Images",
          false,
          308,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-09-18",
          63956492,
          "Ag-grid columnApi applyColumnState function",
          true,
          307,
          2,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-09-28",
          64105918,
          "Can I initialize the checkbox selection in a material-ui DataGrid?",
          true,
          257,
          3,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-09-04",
          63737526,
          "Material-UI - How to open Dialog imperatively/programmatically",
          true,
          249,
          2,
          true,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-09-24",
          64044613,
          "react-hook-form and material-ui FormControl",
          false,
          241,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-08-23",
          63548097,
          "Animation for react-select menu open/close",
          true,
          191,
          2,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-09-02",
          63699270,
          "How to use typescript with the definition of custom styles for a select using react-select",
          true,
          146,
          2,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-10-16",
          64388539,
          "How to Create a Git repository using github-cli?",
          false,
          144,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-09-09",
          63809411,
          "AutoComplete Material-ui React getOptionSelected prop not working",
          true,
          138,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-09-03",
          63716490,
          "Possible to convert tuple to array in TypeScript?",
          true,
          126,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-10-06",
          64222851,
          "How to validate input fields in react?",
          true,
          119,
          2,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-09-19",
          63970898,
          "Yup validation for dynamic checkbox field",
          false,
          119,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-09-17",
          63939079,
          "How to use onChange with react hook on react select to change data base on user select",
          true,
          114,
          1,
          false,
          true,
          null,
          null,
          true,
          true,
        ],
        [
          "2020-08-24",
          63560116,
          "How to apply ag-grid custom filter when clicking a button",
          true,
          106,
          2,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-09-07",
          63771965,
          "React: Convert CSSProperties to Styled-Component",
          true,
          101,
          2,
          false,
          true,
          null,
          null,
          true,
          true,
        ],
        [
          "2020-08-15",
          63421708,
          "How to import ag-grid-enterprise in my Angular 7 project",
          true,
          100,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-08-19",
          63480568,
          "Clickable event on ag-grid",
          true,
          94,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-08-28",
          63636480,
          "Material UI snackbars not working properly in Next JS",
          false,
          94,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-09-23",
          64027357,
          "How to validate material-ui-phone-number with Yup",
          true,
          93,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-09-28",
          64098650,
          "Adding custom drodpdown on column Header in ag-Grid",
          false,
          92,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-08-30",
          63659054,
          'Hide/Remove "Create New" menu in react-select',
          true,
          91,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-10-29",
          64585085,
          "ClickAwayListener doesn't fire when clicking on a link/button to navigate to other route",
          false,
          88,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-09-03",
          63720650,
          "Type error on a React component created with forwardRef",
          true,
          87,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-08-10",
          63334053,
          "How to use the Yield keyword in React?",
          true,
          85,
          2,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-08-30",
          63657083,
          "How to use showLoadingOverlay in ag grid during ngoninit",
          true,
          84,
          3,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-09-12",
          63858060,
          "react hook useState in AgGridColumn onCellClicked function",
          true,
          82,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-09-12",
          63856957,
          "How to set the zIndex on the drawer component",
          true,
          80,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-09-08",
          63787567,
          "CSS: how to create an infinitely-moving repeating linear gradient?",
          true,
          78,
          3,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-09-21",
          63990845,
          "How to get the selection order in ag-Grid?",
          true,
          77,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-09-30",
          64141238,
          "React useEffect to save textarea text",
          true,
          76,
          2,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-09-09",
          63806699,
          "Material UI Autocomplete create clickable Button in noOptionsText",
          true,
          76,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-09-29",
          64113483,
          "Month and Year picker in MaterialUI ReactJS",
          true,
          74,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-08-27",
          63607601,
          "Row count in aggrid with pagination",
          true,
          71,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-10-17",
          64403149,
          "Jest/react-testing-library: Clicking a button didn't update the value in test",
          false,
          69,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-08-26",
          63598309,
          "How to provide background color to x% width of Ag Grid Cell?",
          true,
          66,
          2,
          false,
          true,
          null,
          null,
          true,
          true,
        ],
        [
          "2020-08-15",
          63421888,
          "Ag grid to put border only between group values",
          true,
          66,
          2,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-09-21",
          63986316,
          "useReducer hook, how to typecheck the action?",
          true,
          66,
          2,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-10-17",
          64402946,
          "How to check what react component displays after delay in a test",
          true,
          64,
          2,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-09-03",
          63723014,
          "Vue Ag-grid hide/unhide all columns at once",
          true,
          63,
          2,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-09-06",
          63765900,
          "How to create Bootstrap like border on click in CSS",
          true,
          62,
          2,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-09-18",
          63951477,
          "How to customize Select to display selected options separated by comma? react-select",
          true,
          62,
          1,
          false,
          true,
          null,
          null,
          true,
          true,
        ],
        [
          "2020-09-14",
          63888573,
          "Make id in FormattedMessage from react-intl inherit from a custom TypeScript interface to enable VS IntelliSense and type checking",
          true,
          61,
          2,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-10-03",
          64185640,
          "How to preserve fields in react-hook-form fieldArray?",
          true,
          60,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-09-16",
          63918582,
          "CSS variables in Material ui - createMuiTheme",
          false,
          60,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-10-03",
          64186048,
          "react-hook-form only registers the last step's form data in multi-level form",
          true,
          57,
          2,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-09-06",
          63760676,
          "React context state sharing not working in sibling components",
          true,
          57,
          2,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-09-05",
          63754449,
          "Simple way to programatically remove all grouping and filtering",
          false,
          56,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-10-13",
          64331367,
          "How to add a button to every row in material ui table",
          true,
          54,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-09-30",
          64137147,
          "Updating nested useState seems to modify the original data",
          true,
          53,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-09-11",
          63847429,
          "Dismiss a Material UI Tooltip by Pressing Escape",
          true,
          53,
          2,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-09-14",
          63878189,
          "In ag-grid how to get dynamic header name?",
          false,
          53,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-09-09",
          63812060,
          "Why do so many programmers imports `useState` separately, whereas it would be just as workable to simply use `React.useState`?",
          false,
          52,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-09-10",
          63834063,
          "AG Grid clip long text in cell and show all on click",
          false,
          52,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-09-21",
          63985956,
          "Ag-grid drag and drop doesn't work after sorting rows",
          true,
          52,
          1,
          false,
          true,
          null,
          null,
          true,
          true,
        ],
        [
          "2020-10-02",
          64170995,
          "Styling react-select component with CSS className in Reactjs",
          true,
          52,
          1,
          false,
          true,
          null,
          null,
          true,
          true,
        ],
        [
          "2020-09-30",
          64132614,
          "React Intl, how to add a number in a message?",
          false,
          51,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-09-12",
          63856644,
          "Trying to conditional render css to on alternating items in an array with useState in React with MUI",
          false,
          50,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-10-19",
          64427195,
          "calling setState() will execute the function value instead of passing it",
          true,
          50,
          2,
          true,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-09-29",
          64113150,
          "react functional component with ag grid cannot call parent function via context",
          true,
          50,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-09-19",
          63968681,
          "Ag-Grid Prevent onRowClicked event when clicking icon inside cell",
          true,
          50,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-09-22",
          64003850,
          "Store dropdown selection and load it from localStorage",
          true,
          50,
          2,
          false,
          true,
          null,
          null,
          true,
          true,
        ],
        [
          "2020-09-08",
          63796969,
          "Conditional styling on row for dynamic cell value",
          true,
          50,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-10-04",
          64194897,
          "Min and Max Date in Material UI DatePicker in React",
          true,
          49,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-10-08",
          64255665,
          "React renders the wrong data when deleting the item in the middle of the list",
          true,
          49,
          2,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-08-26",
          63600839,
          "Aggrid get get name of columns displayed in the table",
          true,
          49,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-09-23",
          64026724,
          "Cellrenderer and react-router-dom Link",
          false,
          49,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-10-01",
          64160160,
          "How can I access the custom target attribute within material UI select options in React js",
          true,
          48,
          1,
          false,
          true,
          null,
          null,
          true,
          true,
        ],
        [
          "2020-09-20",
          63977167,
          "ag-grid cell style based on dynamic condition",
          true,
          48,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-10-02",
          64176333,
          "Change the color of Material UI Autocomplete option",
          true,
          47,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-10-14",
          64348035,
          "How to get rid of or remove spinners/arrows in react-select?",
          true,
          47,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-09-19",
          63964974,
          "How to select row when drag start on Ag-grid?",
          true,
          46,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-09-23",
          64023627,
          "AgGridReact - Grid does not update when isRowSelectable changes",
          true,
          46,
          1,
          false,
          true,
          null,
          null,
          true,
          true,
        ],
        [
          "2020-09-23",
          64021767,
          "Best way to add a prefix to a react-select box",
          true,
          45,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-10-05",
          64205366,
          "Why is useMemo used in the MaterialUi documentation for the autocomplete?",
          true,
          45,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-08-30",
          63654691,
          "How to make a (nodeType == Node.ELEMENT_NODE) acts like (nodeType == Node.TEXT_NODE) in context of flex-direction: column CSS",
          true,
          45,
          2,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-09-02",
          63701460,
          "How can I clear autocomplete values",
          false,
          45,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-09-01",
          63687181,
          "Does anyone have a French translation of the AG-Grid?",
          true,
          44,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-09-25",
          64058621,
          "How to make cell content in ag-grid centered vertically?",
          true,
          44,
          2,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-09-26",
          64073988,
          "ag-Grid React forgets gridApi after it has been set",
          true,
          44,
          2,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-10-12",
          64313356,
          "Keep material UI textfield label on top when text field has no value",
          true,
          43,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-09-06",
          63764045,
          "changing default breakpoints in material ui is not working",
          false,
          43,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-10-18",
          64414473,
          "How to add aria-required to Material-UI select component",
          false,
          42,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-10-09",
          64273831,
          "Adding styles to a specific header cell in ag-grid",
          true,
          42,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-08-23",
          63542924,
          "Run function on React.Intl <FormattedMessage>",
          true,
          42,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-08-11",
          63349999,
          "What is the name of row click event in ag-grid-react reactjs?",
          true,
          41,
          1,
          false,
          true,
          null,
          null,
          true,
          true,
        ],
        [
          "2020-10-04",
          64191569,
          "Setting thin width for columns in ag-Grid not working",
          true,
          41,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-09-02",
          63704078,
          "Edit icon not displaying in ag-grid",
          false,
          41,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-09-13",
          63867535,
          "Apply css styles only to the last row in the tree data",
          true,
          40,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-10-01",
          64153055,
          "Editable group cell in ag grid",
          true,
          39,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-10-04",
          64193259,
          "Material UI unable to import and using ClickAwayListener",
          true,
          38,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-09-24",
          64039573,
          "ag-grid-vue not rendering the table",
          true,
          38,
          1,
          false,
          true,
          null,
          null,
          true,
          true,
        ],
        [
          "2020-09-20",
          63975969,
          "Material UI and ReactJS, how to style a selected ListItem using withStyles?",
          true,
          38,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-08-27",
          63607407,
          "Create a button that lowers or increases the column width in ag-grid",
          true,
          38,
          2,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-09-02",
          63705748,
          "AgGrid custom template for no data is not working correctly",
          true,
          38,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-08-03",
          63223105,
          "How to add a select-all chekbox to Column Header in Ag-Grid React?",
          true,
          37,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-10-10",
          64294746,
          "Global theme with TypeScript/React/Material-UI",
          true,
          37,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-10-25",
          64519328,
          "Why does this code does not show buttons on different lines instead of side-by-side?",
          false,
          37,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-10-19",
          64434122,
          "Even Number Counter with React Functional Components",
          true,
          36,
          1,
          false,
          true,
          null,
          null,
          true,
          true,
        ],
        [
          "2020-09-11",
          63849978,
          "Material-ui v4 shows component names in html DOM class attributes?",
          true,
          36,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-09-18",
          63954643,
          "OnBlur closing react component if clicked inside",
          true,
          36,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-09-05",
          63750517,
          "Click icon button in the card component without clicking the whole card",
          true,
          36,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-09-07",
          63779411,
          "react-intl: unicode character",
          true,
          35,
          1,
          false,
          true,
          null,
          null,
          true,
          true,
        ],
        [
          "2020-10-18",
          64412506,
          "How to make popper show the scrollbars when it doesn't fit the viewport?",
          true,
          35,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-08-26",
          63590825,
          "ag-grid rowgroup row color for the entire row",
          false,
          35,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-10-03",
          64181429,
          "Struggling with Material UI styling solution",
          false,
          35,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-10-28",
          64579912,
          "agGrid - How to hide dynamically generated column",
          false,
          34,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-10-17",
          64406072,
          "React Can't Find An Import For Material UI Components",
          true,
          34,
          2,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-08-13",
          63387515,
          "How to change styling of cells that has been edited in ag-Grid?",
          true,
          34,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-09-13",
          63872333,
          "Running two functions on onIonChange in Ionic4 React",
          true,
          33,
          2,
          false,
          true,
          null,
          null,
          true,
          true,
        ],
        [
          "2020-10-20",
          64453081,
          "Expect jest mock to have been called with an argument fails in react testing library",
          true,
          33,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-10-11",
          64306045,
          "How to get Material-UI Button attribute in onClick?",
          true,
          33,
          1,
          false,
          true,
          null,
          null,
          true,
          true,
        ],
        [
          "2020-09-27",
          64085588,
          "For ag-grid, is it possible to access old rowData?",
          true,
          33,
          1,
          false,
          true,
          null,
          null,
          true,
          true,
        ],
        [
          "2020-09-27",
          64086323,
          "AG-grid export to excel with group count",
          false,
          33,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-10-06",
          64224845,
          "ag-grid: is there a way to trigger event when clear range selection",
          false,
          32,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-10-22",
          64478939,
          "react-hook-form handling server-side errors in handleSubmit",
          false,
          32,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-09-20",
          63979882,
          "Error when setting an input in ReactJS, label is over / overwrites the value of the input set, using the material.ui",
          true,
          32,
          1,
          false,
          true,
          null,
          null,
          true,
          true,
        ],
        [
          "2020-09-15",
          63903494,
          "Selecting created option on menu close/select blur using creatable component",
          true,
          32,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-10-13",
          64338071,
          "How to change padding of Material UI's datepicker?",
          true,
          31,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-09-05",
          63754079,
          "How to check the type is enum or not in typescript",
          true,
          31,
          1,
          false,
          true,
          null,
          null,
          true,
          true,
        ],
        [
          "2020-10-29",
          64589625,
          "How to access material theme in shared component in react?",
          false,
          31,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-08-29",
          63647879,
          "convert select component in material ui from fuction to class",
          false,
          31,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-09-09",
          63814169,
          "react-select function call on click event on the chip",
          false,
          31,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-09-06",
          63762672,
          "ReactJS automatically simulate keyboard",
          true,
          30,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-09-08",
          63790213,
          "How to show number of children beside dropdown arrow in ag-grid (react) tree data?",
          true,
          30,
          1,
          false,
          true,
          null,
          null,
          true,
          true,
        ],
        [
          "2020-10-29",
          64596414,
          "How do I show the text longer than the textfield width in the material ui?",
          true,
          29,
          2,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-09-09",
          63805119,
          "aggird export to excel is modifying data of numbers with more than 15 digits",
          false,
          29,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-10-18",
          64418855,
          "Typescript error in ReactJS tests with React Testing Library",
          false,
          29,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-10-18",
          64418952,
          "Typescript error in ReactJS tests with React Testing Library",
          false,
          29,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-10-15",
          64376075,
          "How to change ag-grid row group indent?",
          false,
          29,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-10-15",
          64376468,
          "How to stop agGrid from truncating whitespaces between the values and show the text as is?",
          false,
          29,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-10-14",
          64352997,
          "agGrid how to refresh after change value of checkbox",
          false,
          28,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-10-01",
          64152654,
          "Using HTMLFormElement.reset() with Downshift and react-hook-form",
          false,
          28,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-09-17",
          63930848,
          "Is it possible to put borders around row groups in ag-grid",
          true,
          28,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-09-15",
          63895391,
          "reactjs MUI override style with parent reference",
          true,
          28,
          1,
          false,
          true,
          null,
          null,
          true,
          true,
        ],
        [
          "2020-09-17",
          63937686,
          "How to get the style object of a Row in ag-grid?",
          true,
          28,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-09-23",
          64026242,
          "can we toggle between tree view and flat view?",
          true,
          28,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-09-21",
          63991714,
          "How to specify button Icon using string name in Temporary drawer Material UI",
          true,
          27,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-09-14",
          63886458,
          "How to prevent ReactSelect from clearing the input?",
          true,
          27,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-10-23",
          64500024,
          "Form inside a material-ui Dialog is not submitting on Enter",
          true,
          27,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-10-06",
          64218437,
          "how to expand TextField to full width in the grid container?",
          false,
          27,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-09-18",
          63950742,
          "How to apply style on NoOptionsText in autocomplete material-ui",
          false,
          26,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-10-29",
          64589209,
          "React / Material-UI ListItemText make bolder when Active",
          false,
          26,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-10-27",
          64559128,
          "How to check if a material-ui MenuItem is disabled using react-testing-library",
          true,
          26,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-10-27",
          64558110,
          "How can I check the type of material ui theme in react js? (light or dark)",
          true,
          26,
          1,
          false,
          true,
          null,
          null,
          true,
          true,
        ],
        [
          "2020-09-18",
          63950560,
          "Create a new row through a rendered React component",
          true,
          26,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-09-01",
          63681320,
          "Aggrid refresh after state of rowGroupPanelShow changed",
          true,
          26,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-08-21",
          63518866,
          "Make ag-grid row selectable without a checkbox",
          true,
          25,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-10-28",
          64580149,
          "Material-UI TextField onChange doesn't invoke function in a test",
          true,
          25,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-10-02",
          64167930,
          "Attempted import error: 'useThemeVariants' is not exported from '@material-ui/styles'",
          true,
          25,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-09-03",
          63716920,
          "React Ag grid expandAll in enterprise",
          false,
          25,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-09-04",
          63739910,
          "How can I use a button to change the Theme for material UI on my site? this is where I am so far",
          false,
          25,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-10-20",
          64448766,
          "Unable to see the Tooltip while using Highlighter",
          true,
          25,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-10-09",
          64274083,
          "How to change Dropdown Indicator position on react-select",
          true,
          24,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-09-16",
          63912485,
          "Change row height of pinned columns ag-grid",
          true,
          24,
          1,
          false,
          true,
          null,
          null,
          true,
          true,
        ],
        [
          "2020-10-22",
          64486868,
          "How to format specific words in a sentence in react-intl",
          true,
          23,
          1,
          false,
          true,
          null,
          null,
          true,
          true,
        ],
        [
          "2020-08-25",
          63578763,
          "Is there an event triggered when we navigate from one cell to another in edit mode - ag grid",
          false,
          22,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-10-13",
          64337767,
          "React Material-UI Autocomplete. How to get value of deleted option?",
          false,
          22,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-09-02",
          63699587,
          "React Select adjust the first option layout",
          true,
          22,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-09-11",
          63841400,
          "Radio Button background and checked",
          true,
          22,
          1,
          false,
          true,
          true,
          null,
          true,
          true,
        ],
        [
          "2020-09-04",
          63743814,
          "How I can apply white color for Material UI Icon?",
          true,
          20,
          1,
          false,
          true,
          null,
          null,
          true,
          true,
        ],
        [
          "2020-10-29",
          64595914,
          "How to validate Yup.date() without selecting any dates?",
          false,
          20,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
        [
          "2020-08-09",
          63331587,
          "Why adding a column to ag-grid-react causes all cells to rerender?",
          true,
          19,
          1,
          false,
          true,
          null,
          null,
          true,
          true,
        ],
        [
          "2020-10-16",
          64387861,
          "ag-grid-vue: how to detect row click?",
          false,
          18,
          0,
          false,
          false,
          null,
          null,
          null,
          null,
        ],
      ],
    },
    {
      columns: [
        {
          name: "lastUpdated",
          type: "Text",
        },
        {
          name: "lastUpdatedDate",
          type: "Date",
        },
      ],
      rows: [["4.5 days ago", 1604207141970]],
    },
    {
      columns: [
        {
          name: "postType",
          type: "Text",
        },
        {
          name: "peopleReached",
          type: "Number",
        },
      ],
      rows: [
        ["question", 3534],
        ["answer", 163579],
        ["all", 167113],
      ],
    },
    {
      columns: [
        {
          name: "tag",
          type: "Text",
        },
        {
          name: "viewCount",
          type: "Number",
        },
      ],
      rows: [
        ["ubuntu-16.04", 132802],
        ["yarnpkg", 132802],
        ["ag-grid", 91907],
        ["flutter", 87953],
        ["angular", 80368],
        ["dart", 72224],
        ["reactjs", 56749],
        ["css", 47025],
        ["javascript", 40859],
        ["animation", 37255],
        ["ag-grid-angular", 24398],
        ["ag-grid-ng2", 24051],
        ["image", 21531],
        ["loading", 21531],
        ["state", 21531],
        ["typescript", 13275],
        ["jestjs", 11980],
        ["create-react-app", 11762],
        ["material-ui", 11583],
        ["testing", 9728],
        ["jss", 9593],
        ["node.js", 9117],
        ["git", 9117],
        ["redux", 7401],
        ["ag-grid-react", 7007],
        ["gradient", 6984],
        ["text", 6984],
        ["flutter-layout", 6055],
        ["colors", 3541],
        ["color-scheme", 3541],
        ["uicolor", 3541],
        ["flutter-animatedlist", 3400],
        ["flutter-animation", 3400],
        ["redux-saga", 3349],
        ["react-select", 3239],
        ["themes", 2540],
        ["enzyme", 2130],
        ["jasmine", 1333],
        ["matcher", 1333],
        ["unit-testing", 1058],
        ["wpf", 1000],
        ["textbox", 1000],
        ["shortcut", 1000],
        ["c#", 1000],
        ["visual-studio-code", 987],
        ["avalonedit", 569],
        ["listview", 544],
        ["react-hook-form", 519],
        ["react-hooks", 493],
        ["html", 331],
        ["react-material", 329],
        ["autocomplete", 183],
        ["react-intl", 161],
        ["vue.js", 150],
        ["react-testing-library", 148],
        ["react-native", 138],
        ["styled-components", 101],
        ["yup", 93],
        ["typescript-typings", 87],
        ["yield", 85],
        ["ngoninit", 84],
        ["use-state", 82],
        ["linear-gradients", 78],
        ["background", 78],
        ["css-animations", 78],
        ["date", 74],
        ["datetime", 74],
        ["pagination", 71],
        ["frontend", 68],
        ["bootstrap-4", 62],
        ["twitter-bootstrap", 62],
        ["react-localization", 61],
        ["react-component", 57],
        ["local-storage", 50],
        ["dropdown", 50],
        ["onchange", 48],
        ["select", 48],
        ["react-select-search", 47],
        ["jquery", 45],
        ["flexbox", 45],
        ["jsx", 42],
        ["width", 41],
        ["onclicklistener", 38],
        ["higher-order-components", 38],
        ["ag-grid-vue", 38],
        ["popper.js", 35],
        ["mocking", 33],
        ["ionic4", 33],
        ["file-upload", 33],
        ["enums", 31],
        ["datepicker", 31],
        ["oop", 31],
        ["input", 30],
        ["keyboard", 30],
        ["simulate", 30],
        ["mui-datatable", 28],
        ["navigation", 27],
        ["material-design", 27],
        ["user-interface", 27],
        ["types", 26],
        ["menuitem", 26],
        ["highlighter", 25],
        ["tooltip", 25],
        ["drop-down-menu", 24],
        ["icons", 20],
      ],
    },
    {
      columns: [
        {
          name: "month",
          type: "Text",
        },
        {
          name: "peopleReached",
          type: "Number",
        },
      ],
      rows: [
        ["2018-06", 569],
        ["2019-08", 1000],
        ["2019-10", 11887],
        ["2019-11", 2514],
        ["2019-12", 78080],
        ["2020-07", 7225],
        ["2020-08", 40030],
        ["2020-09", 7138],
        ["2020-10", 18670],
      ],
    },
  ],
}
